import { z } from 'zod';

import { WorkoutPlanId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GeneratePaymentDeferralOfferLetterSideEffectContext = BaseLoanIdSideEffect.extend({
  workoutPlanId: WorkoutPlanId,
});

export const GeneratePaymentDeferralOfferLetterSideEffect = GeneratePaymentDeferralOfferLetterSideEffectContext.extend({
  type: z.literal('generatePaymentDeferralOfferLetter'),
});
export type GeneratePaymentDeferralOfferLetterSideEffect = z.infer<typeof GeneratePaymentDeferralOfferLetterSideEffect>;
